import React, { useState } from 'react';
import { Card, Tabs, Typography } from 'antd';
import { ClockCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet-async';
import ApprovalAttendance from '../ApprovalAttendance/ApprovalAttendance';
import ApprovalUserLeavePaid from '../ApprovalUserLeavePaid/ApprovalUserLeavePaid';

function HRApproval() {
    const [activeKey, setActiveKey] = useState('attendance');

    const items = [
        {
            key: 'attendance',
            label: <span><ClockCircleOutlined /> Attendance Request</span>,
            children: <ApprovalAttendance embedded />,
        },
        {
            key: 'timeoff',
            label: <span><CalendarOutlined /> Time Off Balance Approval</span>,
            children: <ApprovalUserLeavePaid embedded />,
        },
    ];

    return (
        <>
            <Helmet><title>HR Approval</title></Helmet>
            <div style={{ marginBottom: 16 }}>
                <Typography.Title level={3} style={{ marginBottom: 4 }}>HR Approval</Typography.Title>
                <Typography.Text type="secondary">
                    Review attendance submissions and time off balance requests in one place.
                </Typography.Text>
            </div>
            <Card bodyStyle={{ paddingTop: 8 }}>
                <Tabs
                    activeKey={activeKey}
                    items={items}
                    onChange={setActiveKey}
                    destroyInactiveTabPane
                />
            </Card>
        </>
    );
}

export default HRApproval;
